import React from 'react';
import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import { Form } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import Divider from '@dashboard/components/Divider';
import Link from '@dashboard/components/Link/Link';
import PaymentMethodDomains from './components/PaymentMethodDomains';

const SettingsPayments = () => {
  const { seller } = useAuth();

  const { updateSeller } = useSellerQueries();

  return (
    <>
      <SettingsContainer size="xl">
        <SettingsHeader id="payments">Payments</SettingsHeader>

        <div className="my-4 max-w-lg">
          <Form
            enableReinitialize
            initialValues={{
              paymentGateways: seller.paymentGateways && {
                ...seller.paymentGateways,
              },
              captcha: seller.captcha,
              limitSubscriptions: seller.limitSubscriptions,
            }}
            fields={({ values }) => [
              {
                name: 'paymentGateways.stripe.enableAppleGooglePay',
                required: false,
                type: 'checkbox',
                label: 'Enable Apple & Google Pay',
              },
              {
                name: 'captcha.recaptcha.enabled',
                required: false,
                type: 'checkbox',
                label: 'Enable Google reCAPTCHA v3',
                tooltip:
                  'Google reCAPTCHA helps prevent fraudulent payments on your checkout pages by verifying that the person making the payment is a human.',
              },
              {
                name: 'limitSubscriptions.enabled',
                required: false,
                type: 'checkbox',
                label:
                  'Prevent customers from subscribing if they already have a subscription in Checkout Page',
                reduceMargin: values.limitSubscriptions?.enabled,
                tooltip: `Applies to all checkout pages — If the customer email already has an active subscription within Checkout Page, the customer will be shown a message that they can't start another subscription.`,
              },
              {
                name: 'limitSubscriptions.limitSubscriptionsStripe.enabled',
                required: false,
                type: 'checkbox',
                label:
                  'Prevent customers from subscribing if they already have a subscription in Stripe',
                hidden: !values.limitSubscriptions?.enabled,
                tooltip: `If the customer email already has an active subscription in Stripe, the customer will be shown a message that they can't start another subscription.`,
                inset: true,
              },
            ]}
            onSubmit={async values => {
              try {
                const { data } = await updateSeller(values);

                return {
                  data,
                };
              } catch (error) {
                return {
                  error,
                };
              }
            }}
          />
        </div>
      </SettingsContainer>

      <SettingsContainer size="xl">
        <Divider className="my-8" />
      </SettingsContainer>

      <SettingsContainer size="xl">
        <SettingsHeader id="payment-method-domains">Payment method domains</SettingsHeader>
        <div>
          Add your website's domain(s) to enable Apple Pay and Google Pay on checkout embeds and
          pop-ups.{' '}
          <Link
            href="/help/articles/accept-payments-with-card-apple-pay-google-pay"
            color="default"
            blank
          >
            Learn more
          </Link>
        </div>

        <div className="my-4">
          <PaymentMethodDomains />
        </div>
      </SettingsContainer>
    </>
  );
};

export default SettingsPayments;
